<div class="container-fluid p-0">
  @if (isLoading) {
    <shared-skeletons-cards-ngx-datatable-mobile></shared-skeletons-cards-ngx-datatable-mobile>
  } @else {
    <div class="row g-3">
      @for (row of paginatedData; track $index) {
        @if (!row.isTotalRow) {
          <div class="col-12">
            <div class="card m-0 mc-card">
              <div class="card-body p-3">
                <!-- Header del card con título y dropdown de acciones -->
                <div class="d-flex justify-content-between align-items-start mb-3 mc-card-head">
                  @if (mobileTitleColumn?.cellTemplate; as titleTemplate) {
                    <div class="me-3 mc-card-head-text">
                      <ng-container
                        *ngTemplateOutlet="
                          titleTemplate;
                          context: { $implicit: row, row: row, rowIndex: $index, value: row }
                        "></ng-container>
                    </div>
                  } @else {
                    <div class="me-3 text-break mc-card-head-text">
                      <div class="d-flex align-items-baseline mb-1 mc-field-row">
                        @if (getCardTitleColumnName()) {
                          <span class="fw-semibold me-2 small mc-field-label">
                            {{ getCardTitleColumnName() | translate }}:
                          </span>
                        }
                        <h6
                          class="card-title mb-0 text-truncate flex-grow-1"
                          [class.opacity-50]="getCardTitle(row) === 'N/A'"
                          [title]="getCardTitle(row)">
                          {{ getCardTitle(row) }}
                        </h6>
                      </div>
                      @if (getCardSubtitle(row)) {
                        <div class="d-flex align-items-baseline mc-field-row">
                          @if (getCardSubtitleColumnName()) {
                            <span class="fw-semibold me-2 small mc-field-label">
                              {{ getCardSubtitleColumnName() | translate }}:
                            </span>
                          }
                          <p
                            class="card-subtitle mb-0 small text-truncate flex-grow-1"
                            [class.opacity-50]="getCardSubtitle(row) === 'N/A'"
                            [style.color]="getCardSubtitleColor(row)"
                            [title]="getCardSubtitle(row)">
                            {{ getCardSubtitle(row) }}
                          </p>
                        </div>
                      }
                    </div>
                  }

                  <!-- Acciones: usar template directo si existe, sino usar acciones manuales -->
                  @if (actionColumns.length > 0 && !row.isTotalRow) {
                    <div
                      class="d-flex align-items-center justify-content-end flex-wrap gap-1 mc-card-actions">
                      @for (actionColumn of actionColumns; track $index) {
                        @if (actionColumn.cellTemplate) {
                          <ng-container
                            *ngTemplateOutlet="
                              actionColumn.cellTemplate;
                              context: {
                                $implicit: row,
                                row: row,
                                rowIndex: $index,
                                value: null,
                              }
                            "></ng-container>
                        }
                      }
                    </div>
                  } @else if (getVisibleActions(row).length > 0) {
                    <div
                      class="d-flex align-items-center justify-content-end flex-wrap gap-2 mc-card-actions">
                      @for (action of getVisibleActions(row); track $index) {
                        <button
                          class="btn btn-outline-secondary btn-xs"
                          type="button"
                          [ngbTooltip]="action.label | translate"
                          placement="left"
                          [disabled]="isActionDisabled(action, row)"
                          (click)="executeAction(action, row); $event.stopPropagation()">
                          @if (action.icon) {
                            <i [class]="action.icon"></i>
                          }
                        </button>
                      }
                    </div>
                  }
                </div>

                <!-- Contenido del card con los campos de datos (máximo 4) -->
                <div class="card-content">
                  @for (column of getVisibleFields(row); track $index) {
                    @if (column.name || column.prop || column.cellTemplate) {
                      <div class="row align-items-center py-1 border-bottom border-opacity-50">
                        <div class="col-6">
                          <span class="small fw-medium"
                            >{{ column.name || column.prop || 'column' | translate }}:</span
                          >
                        </div>
                        <div class="col-6 text-end">
                          <span
                            class="small"
                            [class.opacity-50]="
                              !hasTemplate(column) && getFieldValue(row, column) === 'N/A'
                            ">
                            @if (hasTemplate(column) && column.cellTemplate) {
                              <!-- Renderizar template directamente -->
                              <ng-container
                                *ngTemplateOutlet="
                                  column.cellTemplate;
                                  context: {
                                    $implicit: column.prop ? getNestedValue(row, column.prop) : row,
                                    row: row,
                                    rowIndex: $index,
                                    value: column.prop ? getNestedValue(row, column.prop) : row,
                                  }
                                "></ng-container>
                            } @else {
                              @if (row.isTotalRow) {
                                <strong>{{ getFieldValue(row, column) }}</strong>
                              } @else {
                                {{ getFieldValue(row, column) }}
                              }
                            }
                          </span>
                        </div>
                      </div>
                    }
                  }
                </div>

                <!-- Botón para ver más detalles -->
                <!-- Botones de acción inferior -->
                <div class="text-center mt-3">
                  <div class="d-flex gap-2 justify-content-center">
                    <!-- Botón para ver más campos -->
                    @if (hasMoreFields(row)) {
                      <button
                        class="btn btn-outline-secondary btn-sm"
                        type="button"
                        (click)="toggleCardExpansion(row); $event.stopPropagation()">
                        @if (isCardExpanded(row)) {
                          {{ 'words.showLess' | translate }}
                        } @else {
                          {{ 'words.showMore' | translate }}
                        }
                      </button>
                    } @else if (isCardExpanded(row) && !hasMoreFields(row)) {
                      <button
                        class="btn btn-outline-secondary btn-sm"
                        type="button"
                        (click)="toggleCardExpansion(row); $event.stopPropagation()">
                        {{ 'words.showLess' | translate }}
                      </button>
                    }

                    <!-- Botón para contenido expandible en offcanvas -->
                    @if (hasExpandableContent(row)) {
                      <button
                        class="btn btn-outline-secondary btn-sm"
                        type="button"
                        (click)="openExpandableOffcanvas(row); $event.stopPropagation()">
                        <!-- <i class="fa fa-chevron-down me-1"></i> -->
                        {{ 'words.advancedDetails' | translate }}
                      </button>
                    }
                  </div>
                </div>
              </div>
            </div>
          </div>
        } @else {
          <!-- Card especial para fila de totales -->
          <div class="col-12">
            <div class="card">
              <div class="card-body p-3">
                <h6 class="card-title mb-3">
                  <i class="fa fa-calculator me-2"></i>
                  {{ 'words.total' | translate }}
                </h6>
                <div class="card-content">
                  @for (column of visibleColumns; track $index) {
                    @if (column.name && (column.prop ? row[column.prop] != null : true)) {
                      <div class="row align-items-center py-1 border-bottom">
                        <div class="col-6">
                          <span class="small fw-medium">{{ column.name | translate }}:</span>
                        </div>
                        <div class="col-6 text-end">
                          <span class="small">
                            <strong>{{ getFieldValue(row, column) }}</strong>
                          </span>
                        </div>
                      </div>
                    }
                  }
                </div>
              </div>
            </div>
          </div>
        }
      }
    </div>

    @if (!data || data.length === 0) {
      <div class="row">
        <div class="col-12">
          <div class="text-center py-5">
            <i class="fa fa-inbox fa-3x mb-3"></i>
            <p>
              {{ config?.emptyMessage || 'No data available' | translate }}
            </p>
          </div>
        </div>
      </div>
    }
    @if (config?.showFooter && data && data.length > 0) {
      <div class="row mt-4">
        <div class="col-12">
          <div class="d-flex justify-content-between align-items-center mb-3 p-3 rounded">
            <!-- Selector de límite de items -->
            <div class="d-flex align-items-center">
              <select
                class="form-select form-select-sm"
                style="width: auto"
                (change)="changeLimit($event)">
                @for (option of config?.limitOptions || []; track $index) {
                  <option [value]="option.value" [selected]="option.value === currentServerLimit">
                    {{ option.label | translate }}
                  </option>
                }
              </select>
            </div>

            <!-- Contador de resultados -->
            <div class="small">
              {{ 'words.results' | translate }}:
              {{ config?.count || data.length || 0 }}
            </div>
          </div>

          <!-- Paginación -->
          @if (totalPages > 1) {
            <nav aria-label="Mobile pagination" class="d-flex justify-content-center">
              <ul class="pagination pagination-sm">
                <!-- Botón anterior -->
                <li class="page-item" [class.disabled]="currentServerPage === 1">
                  <a
                    class="page-link"
                    href="javascript:void(0)"
                    (click)="currentServerPage > 1 && changePage(currentServerPage - 1)"
                    aria-label="Previous">
                    <i class="fa fa-chevron-left"></i>
                  </a>
                </li>

                <!-- Primera página si no está visible -->
                @if (getVisiblePages()[0] > 1) {
                  <li class="page-item">
                    <a class="page-link" href="javascript:void(0)" (click)="changePage(1)"> 1 </a>
                  </li>
                  @if (getVisiblePages()[0] > 2) {
                    <li class="page-item disabled">
                      <span class="page-link">...</span>
                    </li>
                  }
                }

                <!-- Páginas visibles -->
                @for (page of getVisiblePages(); track $index) {
                  <li class="page-item" [class.active]="page === currentServerPage">
                    <a class="page-link" href="javascript:void(0)" (click)="changePage(page)">
                      {{ page }}
                    </a>
                  </li>
                }

                <!-- Última página si no está visible -->
                @if (getVisiblePages()[getVisiblePages().length - 1] < totalPages) {
                  @if (getVisiblePages()[getVisiblePages().length - 1] < totalPages - 1) {
                    <li class="page-item disabled">
                      <span class="page-link">...</span>
                    </li>
                  }
                  <li class="page-item">
                    <a class="page-link" href="javascript:void(0)" (click)="changePage(totalPages)">
                      {{ totalPages }}
                    </a>
                  </li>
                }

                <!-- Botón siguiente -->
                <li class="page-item" [class.disabled]="currentServerPage === totalPages">
                  <a
                    class="page-link"
                    href="javascript:void(0)"
                    (click)="currentServerPage < totalPages && changePage(currentServerPage + 1)"
                    aria-label="Next">
                    <i class="fa fa-chevron-right"></i>
                  </a>
                </li>
              </ul>
            </nav>
          }
        </div>
      </div>
    }
  }

  <!-- Offcanvas para contenido expandible -->
  <div
    class="offcanvas offcanvas-bottom"
    [class.show]="isOffcanvasOpen"
    [style.visibility]="isOffcanvasOpen ? 'visible' : 'hidden'"
    tabindex="-1"
    id="expandableOffcanvas"
    data-bs-backdrop="true"
    data-bs-scroll="false">
    <div class="offcanvas-header border-bottom card mb-0 pb-0">
      <button
        type="button"
        class="btn-close-top-right"
        aria-label="Close"
        (click)="closeOffcanvas()">
        <i class="fa fa-times"></i>
      </button>

      <div
        class="resize-handle mx-auto mb-2 d-flex justify-content-center align-items-center w-100">
        <div class="resize-indicator"></div>
      </div>
    </div>

    <div class="offcanvas-body p-0">
      @if (offcanvasContent && offcanvasRow) {
        <!-- Renderizado con template personalizado -->
        @if (offcanvasContent.expandableRowTemplate) {
          <div class="content-wrapper rounded-0 card mb-0 p-3">
            <!-- Contenido expandible -->
            <div class="expandable-content table-to-cards-wrapper">
              <ng-container
                *ngTemplateOutlet="
                  offcanvasContent.expandableRowTemplate;
                  context: {
                    row: offcanvasRow,
                    rowIndex: 0,
                    expanded: true,
                  }
                "></ng-container>
            </div>
          </div>
        } @else {
          <!-- Renderizado automático por defecto -->
          <div class="content-wrapper p-3">
            <!-- Contenido expandible generado automáticamente -->
            <div class="expandable-content">
              @switch (getExpandableContentType(offcanvasRow)) {
                <!-- Caso 1: Array de objetos (como eventos) -->
                @case ('array') {
                  <div class="row g-3">
                    @for (item of getExpandableArrayData(offcanvasRow); let i = $index; track i) {
                      <div class="col-12">
                        <div class="card event-card">
                          <div class="card-body p-3">
                            <!-- Header del item -->
                            <div class="d-flex justify-content-between align-items-start mb-3">
                              <div class="flex-grow-1 me-3 text-break">
                                <h6
                                  class="card-title mb-1 fw-semibold text-truncate"
                                  [title]="getItemTitle(item)">
                                  {{ getItemTitle(item) }}
                                </h6>
                                @if (getItemSubtitle(item)) {
                                  <p
                                    class="card-subtitle mb-0 small text-truncate"
                                    [title]="getItemSubtitle(item)">
                                    {{ getItemSubtitle(item) }}
                                  </p>
                                }
                              </div>
                              @if (getItemStatus(item)) {
                                <div class="text-end flex-shrink-0">
                                  <span class="badge badge-secondary">
                                    {{ getItemStatus(item) }}
                                  </span>
                                </div>
                              }
                            </div>

                            <!-- Contenido del item en formato grid -->
                            <div class="row g-2">
                              @for (field of getItemFields(item); track $index) {
                                <div class="col-6">
                                  <div class="event-field">
                                    <label class="small fw-medium text-truncate"
                                      >{{ field.label }}:</label
                                    >
                                    <p
                                      class="mb-0 small text-break"
                                      [class.fw-bold]="field.important"
                                      [title]="field.value">
                                      {{ field.value }}
                                    </p>
                                  </div>
                                </div>
                              }
                            </div>
                          </div>
                        </div>
                      </div>
                    }
                  </div>
                }

                <!-- Caso 2: Objeto plano -->
                @case ('object') {
                  <div class="row g-3">
                    <div class="col-12">
                      <div class="card">
                        <div class="card-body p-3">
                          <div class="row g-2">
                            @for (
                              field of getObjectFields(getExpandableObjectData(offcanvasRow));
                              track $index
                            ) {
                              <div class="col-6">
                                <div class="event-field">
                                  <label class="small fw-medium">{{ field.label }}:</label>
                                  <p class="mb-0 small">{{ field.value }}</p>
                                </div>
                              </div>
                            }
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                }

                <!-- Caso 3: Fallback - no hay datos expandibles -->
                @default {
                  <div class="text-center py-5">
                    <p>
                      {{ 'words.noAdditionalDetails' | translate }}
                    </p>
                  </div>
                }
              }
            </div>
          </div>
        }
      }
    </div>
  </div>

  <!-- Backdrop para el offcanvas -->
  @if (isOffcanvasOpen) {
    <div class="offcanvas-backdrop fade show" (click)="closeOffcanvas()"></div>
  }
</div>
